import { combineReducers } from 'redux';

const letterInitialState = {
  loadStatus: 0,
  data: null,
};

const letterEditInitialState = {
  input: {
    content: '',
  },
  saveStatus: 0,
  data: null,
};

function letterReducer(state = letterInitialState, action) {
  switch (action.type) {
    case 'LOAD_LETTER_HOME': {
      return {
        ...state,
        loadStatus: 1,
      };
    }

    case 'LOAD_LETTER_HOME_COMPLETION': {
      const { error, data } = action;
      if (error) {
        return {
          ...state,
          loadStatus: 0,
        };
      }

      return {
        ...state,
        loadStatus: 2,
        data,
      };
    }

    default:
      return state;
  }
}

function letterEditReducer(state = letterEditInitialState, action) {
  switch (action.type) {
    case 'SYNC_LETTER_AGENT_INPUT': {
      return {
        ...state,
        input: {
          ...(action.reset ? letterEditInitialState.input : state.input),
          ...action.input,
        },
      };
    }

    case 'EDIT_LETTER_AGENT': {
      return {
        ...state,
        saveStatus: 1,
      };
    }

    case 'EDIT_LETTER_AGENT_COMPLETION': {
      return {
        ...state,
        saveStatus: action.error ? 0 : 2,
        data: action.data,
      };
    }

    default:
      return state;
  }
}

export default combineReducers({
  letter: letterReducer,
  edit: letterEditReducer,
});
